import { render, staticRenderFns } from "./LoteProducaoMortalidadesTabela.vue?vue&type=template&id=43ab7ec0&"
import script from "./LoteProducaoMortalidadesTabela.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoMortalidadesTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VFlex,VLayout})
